import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceArea } from "recharts";
import { AREAS, AREA_COLORS, LEVELS } from "@/lib/heat";

// points: [{ label, scores: {body,...} }] in chronological order
export const AreaTimeline = ({ points, testId = "area-timeline" }) => {
  const data = points.map((p) => ({ label: p.label, ...p.scores }));
  return (
    <div data-testid={testId} className="avoid-break h-80 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 10, right: 20, bottom: 0, left: -10 }}>
          {LEVELS.map((l) => (
            <ReferenceArea key={l.label} y1={l.min} y2={l.max + (l.max === 36 ? 0 : 1)} fill={l.hex} fillOpacity={0.05} />
          ))}
          <CartesianGrid stroke="#E2E8F0" strokeDasharray="3 3" />
          <XAxis dataKey="label" tick={{ fontSize: 12, fill: "#475569" }} />
          <YAxis domain={[0, 36]} ticks={[0, 12, 21, 29, 36]} tick={{ fontSize: 12, fill: "#475569" }} />
          <Tooltip contentStyle={{ borderRadius: 12, border: "1px solid #E2E8F0" }} />
          <Legend wrapperStyle={{ fontSize: 12 }} itemSorter={(item) => AREAS.findIndex((a) => a.label === item.value)} />
          {AREAS.map((a) => (
            <Line
              key={a.key}
              type="monotone"
              dataKey={a.key}
              name={a.label}
              stroke={AREA_COLORS[a.key]}
              strokeWidth={2.5}
              dot={{ r: 4 }}
              isAnimationActive={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
